const googleLang = {

}

export default {
  google: googleLang
}
